module.exports = __webpack_public_path__ + "static/media/logo-momo.2fc14e80.jpg";